import React from 'react';
import Navbar from '../components/Navbar';
import './Events.css';

const createGoogleCalendarLink = (title, location, details, startDateTime, endDateTime) => {
    const baseUrl = "https://calendar.google.com/calendar/render";
    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: title,
        location: location,
        details: details,
        dates: `${startDateTime}/${endDateTime}`,
    });
    return `${baseUrl}?${params.toString()}`;
};

const Events = () => {
    return (
        <div>
            <Navbar />
            <section className="events section">
                <div className="events-container">
                    <hr className="divider" /> {/* Top Divider */}
                    <h1 className="section-title">Events</h1>
                    <div className="timeline">
                        {/* Thursday Event */}
                        <div className="timeline-event">
                            <div className="event-image">
                                <img
                                    src="/images/events-thursday-event.jpg"
                                    alt="Antonia Rooftop"
                                    className="event-photo"
                                />
                            </div>
                            <div className="event-content">
                                <h2>Thursday</h2>
                                <p>November 6, 2025</p>
                                <h3>Welcome Drinks</h3>
                                <p>
                                    Come enjoy welcome drinks with Tim & Seneca at a rooftop bar in San Miguel de Allende!
                                </p>
                                <p><strong>Antonia Rooftop</strong></p>
                                <p><strong>Address:</strong> San Francisco 57, Zona Centro, 37700 San Miguel de Allende, Gto., Mexico</p>
                                <p><strong>Time:</strong> 6:00 PM local time</p>
                                <div className="event-buttons">
                                    <a
                                        href="https://maps.app.goo.gl/vaLHm9p6jUne5A9UA"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button"
                                    >
                                        Google Maps
                                    </a>
                                    <a
                                        href={createGoogleCalendarLink(
                                            "Welcome Drinks at Antonia Rooftop Bistro",
                                            "San Francisco 57, Zona Centro, 37700 San Miguel de Allende, Gto., Mexico",
                                            "Come enjoy welcome drinks with Tim & Seneca at a rooftop bar in San Miguel de Allende!",
                                            "20251107T000000Z", // Start time (UTC format)
                                            "20251107T020000Z" // End time (UTC format)
                                        )}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button"
                                    >
                                        Add to Calendar
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Friday Event */}
                        <div className="timeline-event-reverse">
                            <div className="event-image">
                                <img
                                    src="/images/events-friday-event.jpg"
                                    alt="Los Milagros"
                                    className="event-photo"
                                />
                            </div>
                            <div className="event-content">
                                <h2>Friday</h2>
                                <p>November 7, 2025</p>
                                <h3>Casual meet up in downtown San Miguel.</h3>
                                <p>Today is a free day! Enjoy any of the fun activities around San Miguel! At night, if you'd like to join, Tim & Seneca will be at the bar around 7:00 PM to spend time with guests.</p>
                                <p><strong>El Manantial</strong></p>
                                <p><strong>Address: </strong>Barranca 78, Zona Centro, 37700 San Miguel de Allende, Gto., Mexico</p>
                                <p><strong>Time:</strong> 7:00 PM</p>
                                <div className="event-buttons">
                                    <a
                                        href="https://www.google.com/maps/place/El+Manantial/@20.9124826,-100.7601449,15z/data=!4m10!1m3!11m2!2sW38b1f5VXV5T-7j-6y0lKUAXbuamBw!3e3!3m5!1s0x842b51bb0371d853:0x3ac8712fe6b19890!8m2!3d20.91125!4d-100.740448!16s%2Fg%2F11bwkg0t3_?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button"
                                    >
                                        Google Maps
                                    </a>
                                    <a
                                        href={createGoogleCalendarLink(
                                            "Free day and casual meet up at El Manantial.",
                                            "Barranca 78, Zona Centro, 37700 San Miguel de Allende, Gto., Mexico",
                                            "Today is a free day! Enjoy any of the fun activities around San Miguel! At night, if you'd like to join, Tim & Seneca will be at the bar around 7:00 PM to spend time with guests.",
                                            "20251107T010000Z", // Start time (UTC format)
                                            "20251107T030000Z" // End time (UTC format)
                                        )}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button"
                                    >
                                        Add to Calendar
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Saturday Event */}
                        <div className="timeline-event">
                            <div className="event-image">
                                <img
                                    src="/images/events-saturday-event.jpg"
                                    alt="Casa Adela"
                                    className="event-photo"
                                />
                            </div>
                            <div className="event-content">
                                <h2>Saturday</h2>
                                <p>November 8, 2025</p>
                                <p>Wedding day! We can't wait to celebrate with you!</p>
                                <p><strong>Casa Adela</strong></p>
                                <p><strong>Address: </strong>66, 5 KM, 37800 San Miguel de Allende, Gto., Mexico</p>
                                <p><strong>Ceremony: </strong>4:00 PM</p>
                                <p><strong>Cocktail Hour: </strong>4:30 PM</p>
                                <p><strong>Reception: </strong>5:30 PM</p>
                                <div className="event-buttons">
                                    <a
                                        href="https://www.google.com/maps/place/Casa+Adela/@21.025032,-100.7954651,16.47z/data=!4m9!3m8!1s0x842b51b0cb2f8f57:0xe01024c2adc0dd7a!5m2!4m1!1i2!8m2!3d21.0247373!4d-100.7916959!16s%2Fg%2F11gy2rbxl_?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button"
                                    >
                                        Google Maps
                                    </a>
                                    <a
                                        href={createGoogleCalendarLink(
                                            "Wedding day at Casa Adela!",
                                            "66, 5 KM, 37800 San Miguel de Allende, Gto., Mexico",
                                            "Wedding day is finally here! We can't wait to celebrate with you!",
                                            "20251108T220000Z", // Start time (UTC format)
                                            "20251109T100000Z" // End time (UTC format)
                                        )}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="button"
                                    >
                                        Add to Calendar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default Events;
